module.exports = "/packs/media/images/icons/default_retirement-ed4500f845c0f575920531a2c44ccc72.png";